import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726123200442/pc_ksp_01_base.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726123200442/pc_ksp_01_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725962214614/m_ksp_01.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725594352340/pc_ksp_01.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1725594352340/pc_ksp_01.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725594663325/m_ksp_01.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={styles.itemSelling}>
            <EfImg pc={bg.pc} pad={bg.pad} h5={bg.h5} />
            <div className="item-desc-a">{t('a_ms1')}</div>
        </div>
    );
}
